// extracted by mini-css-extract-plugin
export default {"container":"rootLayout_container__rNpTq","container__outlet":"rootLayout_container__outlet__vFoma","container__outlet__box":"rootLayout_container__outlet__box__zjvTa"};